import request from '@/utils/request'

// v80b1030List
export function v80b1030List(param) {
    let data = param
    return request({
      url: `/v80/v80b1030/v80b1030List`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }

  // v80b1030FileList
  export function v80b1030FileList(param) {
    let data = param
    return request({
      url: `/v80/v80b1030/v80b1030FileList`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
  }